"use client";

import React from "react";

import { Category, Brand } from "../../../../payload/payload-types";
import { Checkbox } from "../../../_components/Checkbox";
import { HR } from "../../../_components/HR";
import { RadioButton } from "../../../_components/Radio";
import { useFilter } from "../../../_providers/Filter";

import classes from "./index.module.scss";

const Filters = ({ categories, brands }) => {
  //The props were like this befor but i had to remove them --- { categories, brands }: { categories: Category[], brands: Brand[] }
  const {
    categoryFilters,
    brandFilters,
    sort,
    setCategoryFilters,
    setBrandFilters,
    setSort,
  } = useFilter();

  const handleCategories = (categoryId: string) => {
    if (categoryFilters.includes(categoryId)) {
      const updatedCategories = categoryFilters.filter(
        (id) => id !== categoryId
      );

      setCategoryFilters(updatedCategories);
    } else {
      setCategoryFilters([...categoryFilters, categoryId]);
    }
  };

  const handleBrands = (brandId: string) => {
    if (brandFilters.includes(brandId)) {
      const updatedBrands = brandFilters.filter((id) => id !== brandId);
      setBrandFilters(updatedBrands);
    } else {
      setBrandFilters([...brandFilters, brandId]);
    }
  };

  const handleSort = (value: string) => setSort(value);

  return (
    <div>
      <div className={classes.filters}>
        <div>
          <h6 className={classes.title}>Product Categories</h6>
          <div className={classes.categories}>
            {categories?.map((category) => {
              const isSelected = categoryFilters.includes(category.id);

              return (
                <Checkbox
                  key={category.id}
                  label={category.title}
                  value={category.id}
                  isSelected={isSelected}
                  onClickHandler={handleCategories}
                />
              );
            })}
          </div>
          <HR className={classes.hr} />
          <h6 className={classes.title}>Product Brands</h6>
          <div className={classes.categories}>
            {brands?.map((brand) => {
              const isSelected = brandFilters.includes(brand.id);

              return (
                <Checkbox
                  key={brand.id}
                  label={brand.title}
                  value={brand.id}
                  isSelected={isSelected}
                  onClickHandler={handleBrands}
                />
              );
            })}
          </div>

          <HR className={classes.hr} />
          <h6 className={classes.title}>Sort By</h6>
          <div className={classes.categories}>
            <RadioButton
              label="Latest"
              value="-createdAt"
              isSelected={sort === "-createdAt"}
              onRadioChange={handleSort}
              groupName="sort"
            />
            <RadioButton
              label="Oldest"
              value="createdAt"
              isSelected={sort === "createdAt"}
              onRadioChange={handleSort}
              groupName="sort"
            />
          </div>
        </div>
      </div>
      <div className={classes.filtersMobile}></div>
    </div>
  );
};

export default Filters;
